export default "/images/b9c0313961180d16b78889abcaf5aa37.avif";